// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ActingProfileCharacterType extends TrackingModel {
	public ActingProfileCharacterTypeId: number = 0;
	public ActingProfileId: number = 0;
	public CharacterTypeId: number = 0;
}